<div class="tooltip">
  <div class="inner">{{label}}</div>
  <div class="triangle" [ngStyle]="{'left.px': triangleLeft}"></div>
</div>